import Api from './rest/SpecItemApi';

export default new Api();
